import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface BulkShiftReadyForDownloadProps extends BaseTemplateProps {
  reviewLink: string
}

export const BulkShiftReadyForDownload: TemplateDefinition<BulkShiftReadyForDownloadProps> = {
  renderParams: (props: BulkShiftReadyForDownloadProps) => ({
    messageKey: 'notificationsDomain.templates.bulkShiftReadyForDownload',
    values: {
      givenName: props.givenName,
      reviewLink: props.reviewLink,
    },
  }),
  getLink: (props: BulkShiftReadyForDownloadProps): string => props?.reviewLink || '',
}
